export default __webpack_public_path__ + "static/media/card-1-bg-mb@2x.8ba01728.jpg";